"use strict";

require("core-js/modules/esnext.weak-map.delete-all.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireWildcard(require("./Icon"));
const _excluded = ["fill"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const IconAPIDocumentation = _ref => {
  let {
      fill
    } = _ref,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    label: "API Documentation"
  }, others), /*#__PURE__*/_react.default.createElement("rect", {
    x: "8.63717",
    y: "3",
    width: "1.65634",
    height: "9.60001",
    transform: "rotate(18.6494 8.63717 3)",
    fill: fill
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8334 8.96214L14.8362 8.96492L15.9885 7.80707L15.9999 7.79565L15.9999 7.79562L16 7.79553L15.9598 7.75553L14.8333 6.62907L14.8306 6.63179L12.3297 4.14287L11.1659 5.31226L13.664 7.79837L11.1718 10.2906L12.3384 11.4572L14.8334 8.96214Z",
    fill: fill
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16656 6.63788L1.16377 6.6351L0.0109666 7.79348L7.04863e-05 7.80437L9.67623e-05 7.8044L4.79772e-07 7.80449L0.0401218 7.84442L1.16665 8.97095L1.16937 8.96824L3.67032 11.4572L4.83408 10.2878L2.33595 7.80165L4.82815 5.30945L3.66157 4.14287L1.16656 6.63788Z",
    fill: fill
  }));
};
IconAPIDocumentation.defaultProps = {
  fill: 'black'
};
IconAPIDocumentation.propTypes = Object.assign({}, _Icon.propTypes, {
  fill: _propTypes.default.string
});
var _default = exports.default = IconAPIDocumentation;